import React, {Component} from 'react'
import { Input, InputNumber, Radio, Select } from 'antd'
const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

const { Option } = Select;

export const inputTax = (inputForm, disabledInput, selectDropDown, disabledRadio, nameInput = false) => {
    if(nameInput == 'childBirthBefore2561' || nameInput == 'childBirthAfter2561' || nameInput == 'adoptedChild' ){
        return <InputNumber 
                    className={ !disabledInput ? '' : 'font-italic' } 
                    disabled={disabledInput}
                    // min={inputForm.min}
                    // max={inputForm.max ? inputForm.max : 99999999}
                />
    }else if(inputForm.type == 'text'){
        return  <Input 
                    className={ !disabledInput ? '' : 'font-italic' }
                    disabled={disabledInput}
                    maxLength={inputForm.max ? inputForm.max : 99999999}
                />
    }else if(inputForm.type == 'number'){
        return  <InputNumber
                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    className={ !disabledInput ? '' : 'font-italic' } 
                    disabled={disabledInput}
                    min={inputForm.min}
                    max={inputForm.max ? inputForm.max : 99999999}
                    step={1000.000}
                />
    }else if(inputForm.type == 'radio'){
        return 	<Radio.Group disabled={disabledInput}>
                    {
                        inputForm.radioChoices.map((valueRadio, keys) =>{
                            return <Radio style={radioStyle} value={parseInt(valueRadio.value)} disabled={!disabledRadio? true : false}>
                                { valueRadio.label }
                            </Radio>
                        })
                    }
                </Radio.Group>
        
    }else if(inputForm.type == 'int'){
        // return <Input 
        //             className={ !disabledInput ? '' : 'font-italic' }
        //             disabled={disabledInput}
        //             type={"number"}
        //             className="numberTax"
        //             maxLength={inputForm.max ? inputForm.max : 99999999}
        //         />
        return <input name="pincode"
                    onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0,e.target.maxLength);
                    }}
                    type = "number"
                    maxlength = {inputForm.max ? inputForm.max : 99999999}
                    className="numberTax"
                />
    
    }else if(inputForm.type == 'textArea'){
        return   <Input.TextArea
                    className={ !disabledInput ? '' : 'font-italic' } 
                    disabled={disabledInput}
                />
    }else if(inputForm.type == 'date'){
        return <Input 
                    className={ !disabledInput ? '' : 'font-italic' } 
                    disabled={disabledInput}
                />
    }else if(inputForm.type == 'dropdown'){
        return <Select  style={{ width: "100%" }}  disabled={disabledInput}>
                    {
                        selectDropDown.map((value, keys)=>
                            <Option value={ value.id }>{ value.label } </Option>
                        )
                    }
                </Select>
    }
}

export const  checkTypeInputButton = (name, value) =>{
    if(
        name == 'childReduce1' ||
        name == 'childReduce2' ||
        name == 'childReduce3' ||
        name == 'spouFatherReduAmnt' ||
        name == 'fatherHealthInsurance' ||
        name == 'spouFaHealthInsurance' ||
        name == 'spouMotherReduAmnt' ||
        name == 'matherHealthInsurance' ||
        name == 'spouMaHealthInsurance' ||
        name == 'lessAllowance' ||
        name == 'healthInsurance' ||
        name == 'insuraAmount' ||
        name == 'rmfDeposit' ||
        name == 'ssfDeposit' ||
        name == 'interestLoan' ||
        name == 'accumulateSocial' ||
        name == 'donationEducate' ||
        name == 'donationCharity' ||
        name == 'childBirthBefore2561' ||
        name == 'childBirthAfter2561' ||
        name == 'adoptedChild' ||
        name == 'isNumberOfDisabled' ||
        name == 'fatherReduAmnt' ||
        name == 'motherReduAmnt'
    ){
        return parseFloat(parseFloat(value));
    }
}

export const  checkTypeInputButtonNews = (name, value) =>{
    if(
        name == 'fatherReduAmnt' ||
        name == 'motherReduAmnt' ||
        name == 'spouFatherReduAmnt' ||
        name == 'spouMotherReduAmnt'
    ){
            return true;
    }
}